import { createBypassSession, LOGIN_TYPE, logo, setCookie } from "@cash/shared-components";
import { useState, useEffect } from "react";
import {
  View,
  Well,
  Grid,
  Flex,
  TextField,
  Button,
  defaultTheme,
  Provider,
} from "@adobe/react-spectrum";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [emailAddress, setEmailAddress] = useState("admin");
  const getConfigData = async () => {
    const res = await axios.get("/root/getConfig");
    setUserPassword(res.data.LOGIN_PASSWORD);
  };

  useEffect(() => {
    const getData = async () => {
      await getConfigData();
    };
    getData();
  }, []);

  const onLogin = () => {
    if (emailAddress !== 'admin' || password !== userPassword) return;
    setCookie("login_type", LOGIN_TYPE.BYPASS, 30);
    localStorage.setItem("lastActivity", Date.now().toString());
    window.location.replace("/home");
  };

  return (
    <>
      <Header
        showLogo={true}
        showHome={false}
        showLogout={false}
        title={
          <div className="sub-logo" style={{ alignItems: "center" }}>
            <h6 className="dashboard-title"></h6>
            <span style={{ fontSize: "25px" }}>
              <span className="logo">Content Automation Solutions Hub (CASH)</span>
            </span>
          </div>
        }
      />
      <Provider theme={defaultTheme} colorScheme="light">
        <View width={"95%"} margin={"auto"} minHeight={"89vh"}>
          <Grid
            justifyContent={"center"}
            areas={[
              "left-top center-top right-top",
              "left-center center-center right-center",
              "left-bottom center-bottom right-bottom",
            ]}
            columns={["1fr", "1fr", "1fr"]}
            rows={["1fr", "3fr", "1fr"]}
          >
            <Well gridArea={"center-center"}>
              <Grid
                justifyContent={"center"}
                areas={["top", "center", "bottom"]}
                columns={[".75fr"]}
                rows={["0.5fr", "1fr", "1fr"]}
                gap={"size-100"}
              >
                <Flex
                  direction={"column"}
                  gridArea={"center"}
                  justifyContent={"space-between"}
                >
                  <TextField
                    label="User Name"
                    value={emailAddress}
                    onChange={setEmailAddress}
                    type="email"
                    width={"100%"}
                    onKeyDown={(e) => {
                      return e.key === "Enter" ? onLogin() : null;
                    }}
                  />
                  <TextField
                    label="Password"
                    value={password}
                    UNSAFE_className="validation-check"
                    onChange={setPassword}
                    type="password"
                    validationState={password === userPassword ? "valid" : "invalid"}
                    width={"100%"}
                    onKeyDown={(e) => {
                      return e.key === "Enter" ? onLogin() : null;
                    }}
                  />
                </Flex>
                <Flex
                  direction={"column"}
                  gridArea={"bottom"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Button
                    UNSAFE_className="btn btn-primary btn-login"
                    onPress={() => {
                      onLogin();
                    }}
                    variant="accent"
                    UNSAFE_style={{ backgroundColor: "#071d49" }}
                  >
                    Login
                  </Button>
                </Flex>
              </Grid>
            </Well>
          </Grid>
        </View>
      </Provider>
      <footer className="dashboard-footer">
        <nav>
          <ul
            style={{
              display: "flex",
              listStyleType: "none",
              padding: 0,
              margin: 0,
            }}
          >
            <li style={{ marginRight: "20px" }}>
              <a href="/home" style={{ color: "inherit", textDecoration: "none" }}>
                Content Automation Solutions Hub (CASH)
              </a>
            </li>{" "}
          </ul>
        </nav>
        <img src={logo} alt="Company Logo" className="footer-logo" />
      </footer>
    </>
  );
};

export default Login;